import crypto from 'crypto'

export const hashKey = (key: string) => {
  return crypto.createHash('md5').update(key).digest('hex')
}
